import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 73 72",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { opacity: "0.5" }, [
      _createElementVNode("path", {
        d: "M67.8085 0H12.6566C8.01423 0 5.70586 5.6277 9.0111 8.88766L64.163 63.284C67.4436 66.5198 73 64.1957 73 59.5879V5.19149C73 2.32431 70.6757 0 67.8085 0Z",
        fill: "#9E579E"
      }),
      _createElementVNode("path", {
        d: "M41.5741 24.75H13.7973C9.15485 24.75 6.84648 30.3777 10.1517 33.6377L37.9286 61.0341C41.2093 64.2698 46.7656 61.9458 46.7656 57.3379V29.9415C46.7656 27.0743 44.4413 24.75 41.5741 24.75Z",
        fill: "#3DABE0"
      }),
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M46.7654 46.125V29.9415C46.7654 27.0743 44.4411 24.75 41.5739 24.75H25.0935L46.7654 46.125Z",
        fill: "#0F4499"
      })
    ], -1)
  ])))
}
export default { render: render }